const DragHandleLines = () => (
  <>
    <path
      fill="currentColor"
      d="M5.5 14.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 5.5 13.5h13q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143zm0-4a.48.48 0 0 1-.356-.144A.49.49 0 0 1 5 9.999q0-.212.144-.356A.49.49 0 0 1 5.5 9.5h13q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356a.48.48 0 0 1-.356.143z"
    />
  </>
)
export default DragHandleLines
